export default {
  tabsLabel: {
    id: 'header_bo_tabs_label',
    defaultMessage: 'Links sales',
  },
  buybackWishlist: {
    id: 'header_bo_buyback_listings',
    defaultMessage: 'Offers',
  },
  buybackOrders: {
    id: 'header_bo_buyback_orders',
    defaultMessage: 'Orders',
  },
  buybackInvoices: {
    id: 'header_bo_buyback_invoices',
    defaultMessage: 'Invoices',
  },
  options: {
    id: 'header_bo_options',
    defaultMessage: 'Options',
  },
  support: {
    id: 'header_bo_support',
    defaultMessage: 'Support',
  },
  opportunities: {
    id: 'header_bo__buyback_opportunities',
    defaultMessage: 'Opportunities',
  },
}
